// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type ToolConfigSchema } from "../../api";
import { useGetToolConfigSchema as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useToolConfigSchemaQueryKey(toolId: string): QueryKey {
  return ["api", "v1", "tools", toolId, "config-schema"];
}

export function useToolConfigSchema(
  toolId: string,
  options: Omit<
    UseQueryOptions<ToolConfigSchema, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): ToolConfigSchema {
  const getter = useGetter();
  return useQuery(
    useToolConfigSchemaQueryKey(toolId),
    () => getter(toolId),
    options
  ).data!;
}
